import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import { ISPForm } from '.';

type PreviewProps = {
    test: Test
}

export class ISPRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <ISPForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}